import React from 'react'
import LibraryChapter from './LibraryChapter'
import { Link, NavLink } from 'react-router-dom'


export default function LibraryChapterProps({ chapterData, books, indexOfBook }) {
  return (
    // <div className='d-flex flex-wrap justify-content-start '>
    <div className='chapterBox'>
      {chapterData.length > 0 && chapterData.map((obj, index) => (
        <NavLink to={`/Library/ChapterDetails/${index}/${0}`} className='link' state={{ chapters: books, chapter_id: obj?.id }}>
          <LibraryChapter
            chapterNo={index}
            chapterName={obj?.chapterName}
            StudyMaterial={`${obj?.countMaterials} Study Material`}
            chapterImg="/LibraryImg/chapter1.svg"
            books={books}
            indexOfBook={indexOfBook}
          // Progress='Completed'
          />
        </NavLink>
      ))}
    </div>
  )
}
